<div class="d-flex flex-column justify-content-center">
  <div class="row loading-row" *ngIf="loading">
    <div class="col-12">
      <div class="spinner">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
    </div>
  </div>

  <form (submit)="createNewPassword()" class="form-inline" [formGroup]="form" >
    <span class="info" @loginItem>{{ title }}</span>
    <app-alert [message]="message" [type]="messageType"></app-alert>
    <div class="login-input-container" @loginItem>
      <label class="sr-only" for="password">Password</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><img src="./assets/ui/svg/grey/icon-password.svg"/></div>
        </div>
        <div class="vertical-divider"></div>
        <input type="password" id="password" name="password" placeholder="Password" #passwordInput formControlName="password" autocomplete="email" autofocus>
      </div>
    </div>
    <div class="login-input-validation" @loginItem>
      <span class="title">Password must:</span>
      <span [ngClass]="form.controls.password.hasError('required') || form.controls.password.hasError('minlength') ? 'not-validate' : 'validate'">
        <span class="bullet"></span>
        <span>be 8 characters long</span>
      </span>
      <span [ngClass]="form.controls.password.hasError('digits') ? 'not-validate' : 'validate'">
        <span class="bullet"></span>
        <span>have at least one digit</span>
      </span>
    </div>

    <button @loginItem type="submit" [class]="loading || !form.valid ? 'non-active' : 'active'" [disabled]="loading || !form.valid">Change my password</button>
  </form>
</div>
